export default "__VITE_ASSET__Ceu5gP29__"